import axios, {  AxiosInstance } from "axios";
import throwError from "../service/throwError";
import {
  OpeningRes,
  getOpeningRes,
  createOpeningMembershipRes,
  getOpeningListsRes,
  ApplicantRes,
  ListRes,
  createBoardCalRes,
  getListByListIDsRes,
  ApplicantLabelRes,
  getOpeningMembersRes,
  getBoardLabelRes,
  getApplicantCommentsRes,
  CommentRes,
  ApplicantMembershipRes,
  getArchivedApplicantsRes,
  getArchivedListsRes,
  getApplicantAttachmentsRes,
  AddAttachmentRes,
  AddAttachment,
  updateApplicantAttachmentRes,
  registrationRes,
  Register,
  JWTtokenExchangeRes,
  getOrgMemberRes,
  ActivityRes,
  inviteMemberRes,
  copyAttachmentsRes,
  getFreeTierQuotaRes,
  CreateCardEventRes,
  getCalenderRes,
  getCardEventRes,
  getBoardCalendarEventRes,
  changeBoardVisibilityRes,
  deleteCalEventRes,
  getEventByIDRes,
  getEventAttachmentRes,
  deleteCalAttachmentRes,
  getCandidatesRes,
  removeZoomFromBoardUsingCalIDRes,
  getCandidateRes,
  getReviewCommentsRes,
  createReviewCommentRes,
  attachLabelToCandidateRes,
  candidateLabel,
  assignMemberToReviewRes,
  AssignMemberToReview,
  attachLabelToReviewRes,
  updateCandidateAttachmentRes,
 
  editCommentOfReviewRes,
  bulkLabel,
  addLabelToBulkReviewRes,
  bulkMember,
  addMembersToBulkReviewRes,
  uploadAttachmentOfCandidateRes,
  getCandidateApplicationRes,
  reviewsLabel,
  attachBulkLabelsToCandidatesRes,
  PaginationCandidates,
  getReviewsOfSelectedCandidate,
  sendMailres,
  paginationMail,
  getUserInboxRes,
  getThreadOfMessageRes,
  markMailAsReadRes,
  addCustomDomainRes,
  verifyDomainRes,
  sentOtpToUserPhoneRes,
  getMappingRes,
  getAllNotificationsRes,
  addWatcherRes,
  getAllMappingsRes,
  updateMappingRes,
  getWatcherRes,
  PaginationActivity,
  ActivityPaginationRes,
  ImportReport,
  getWatcherOfModelRes,
  createOrgRes,
  newOrganisation,
  SourcesResponse,
  Source,
  guestLoginRes,
  Login,
  generateSecureLinkRes,
  Secret,
} from "./apiRes";
import {
  atsUploadHeader,
  authHeader1,
  authHeader,
} from "../service/authHeaders";
import {
  Applicant,
  comment,
  Label,
  List,
  Member,
  Opening,
  OutgoingInvitations,
  Candidate,
  Attachment,
  CandidateShortReview,
  ReviewComment,
  paginationDetails,
  SendMail,
  RecordThreads,
  Mail,
  Domain,
  activity,
  FormBuilder,
  Jd,
  User,
} from "../type/type";
import {
  updatedOpeningReq,
  AddMemberReq,
  createBoardCalenderReq,
  createCardEventReq,
  AddCommentOnReviewReq,
  AssignMemberToReviewReq,
  EditCommentOfReviewReq,
  addLabelsToBulkReviewReq,
  deleteLabelFromCandidateReq,
  sendMailReq,
  checkOtpToUserPhoneReq,
  addWatcherReq,
  addCustomDomainReq,
  attachLabelToCandidateReq,
  addMembersToBulkReviewReq, 
} from "./apiReq";
import { SOCKET_CLIENT_ID } from "../constant";
const epBoard = "/v1/ats/openings/";
const epList = "/v1/ats/lists/";
const epLabels = "/v1/ats/labels/";
const epMembers = "/v1/ats/members/";
const epApplicant = "/v1/ats/applicants";
const epComments = "/v1/ats/comments";
const epAttachment = "/v1/ats/attachments/";
const epFusion = "/v1/orgs/auth/user/";
const epNotification = "/v1/notifications/";
const epDbmanager = "/v1/dbmanager/";
const epActivity = "/v1/activity/";
const epBilling = "/v1/billing/"
const epOpa = "/v1/ats/resource/";
const epCDB = "/v1/db/";
const epCalender = "/v1/calendar/";
const epMail = "/v1/mail/";
const epJD = "/v1/jd/";
const epPublicService = "/v1/public/jobs/"
const epRTU="/v1/rtu";
let api: AxiosInstance;

export const configureAPI = (baseURL: string | undefined) => {
  api = axios.create({ baseURL: baseURL });
};
/**************************************** Ats api *********************************************************/
//openings
export function getOpenings() {
  const ep = epBoard;
  
  return new Promise<Opening[]>((resolve, reject) => {
    api
      .get<getOpeningRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.openings);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
}


export const getBoardByid = (id: string) => {
  const ep = epBoard + id;
  return new Promise<Opening>((resolve, reject) => {
    api
      .get<OpeningRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200 && res.data.opening) {
          resolve(res.data.opening);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const updateOpening = (updatedOpening: updatedOpeningReq) => {
  const ep = epBoard + "update/" + updatedOpening.id;
  return new Promise<Opening>((resolve, reject) => {
    api
      .put<OpeningRes>(ep, updatedOpening, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200 && res.data.opening) {
          resolve(res.data.opening);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const changeBoardVisibility = (req: any) => {
  const ep = `${epOpa}accessibility/transfer`;
  return new Promise((resolve, reject) => {
    api
      .put<changeBoardVisibilityRes>(ep, req, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200 && res.data.accessibility) {
          resolve(res.data.accessibility);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const createOpeningMembership = (req: AddMemberReq) => {
  const ep = epMembers + "openingMembership/" + req.id;
  return new Promise<Member[]>((resolve, reject) => {
    api
      .post<createOpeningMembershipRes>(ep, req, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200 && res.data.members) {
          resolve(res.data.members);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const removeOpeningMembership = (req: any) => {
  const ep = epMembers + "openingMembership/" + req.opening_id;
  return api.delete(ep, { headers: authHeader(), data: req });
};

//list
export const createList = (newList: any) => {
  const ep = epList + newList.opening_id;
  return new Promise<List>((resolve, reject) => {
    api
      .post<ListRes>(ep, newList, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200 && res.data.list) {
          res.data.list.applicants = [];
          resolve(res.data.list);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const getListByListIDs = (openingID: string) => {
  const ep = epList + openingID;
  return new Promise<List[]>((resolve, reject) => {
    api
      .get<getListByListIDsRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.lists_with_applicants);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const getOpeningLists = (openingID: string) => {
  const ep = epList + `ids/${openingID}`;

  return new Promise<List[]>((resolve, reject) => {
    api
      .get<getOpeningListsRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.lists);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const editListName = (req: any) => {
  const ep = epList + "name/" + req.id;
  return new Promise<List>((resolve, reject) => {
    api
      .put<ListRes>(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.list);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const archieveUnArchiveList = (req: any) => {
  const ep = epList + `archiveUnarchive/` + req.id;
  return new Promise<List>((resolve, reject) => {
    api
      .put<ListRes>(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.list);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};


export const getApplicant = (applicantID: string) => {
  const ep = epApplicant + `/${applicantID}`;
  return new Promise<Applicant>((resolve, reject) => {
    api
      .get<ApplicantRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          const applicant: Applicant = res.data.applicant;
          resolve(applicant);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const editApplicantDescription = (desc: any) => {
  const ep = epApplicant + "/description/" + desc.id;
  return new Promise<Applicant>((resolve, reject) => {
    api
      .put<ApplicantRes>(ep, desc, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.applicant);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const editApplicantName = (req: any) => {
  const ep = epApplicant + "/name/" + req.id;

  return new Promise<Applicant>((resolve, reject) => {
    api
      .put<ApplicantRes>(ep, req, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.applicant);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const createApplicantLabel = (label: any) => {
  const ep = epLabels + "applicant/" + label.applicant_id;
  return new Promise<Label>((resolve, reject) => {
    api
      .post<ApplicantLabelRes>(ep, label, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.applicant_label);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const getOpeningMembers = (openingID: string, applicationId: string) => {
  const ep = `${epMembers}${openingID}/${applicationId}/openingMembers`;
  return new Promise<Member[]>((resolve, reject) => {
    api
      .get<getOpeningMembersRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          res.data.members = res.data.members ? res.data.members : [];
          resolve(res.data.members);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const getBoardLabel = (openingID: any) => {
  const ep = epLabels + "opening" + "/" + openingID + "/";
  return new Promise<Label[]>((resolve, reject) => {
    api
      .get<getBoardLabelRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.labels);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const getApplicantComments = (applicantID: string) => {
  const ep = epComments + `/${applicantID}/applicant`;
  return new Promise<comment[]>((resolve, reject) => {
    api
      .get<getApplicantCommentsRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.comments);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const createComment = (newComment: any) => {
  const ep = epComments + "/" + newComment.applicant_id;
  return new Promise<comment>((resolve, reject) => {
    api
      .post<CommentRes>(ep, newComment, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.comment);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const editComment = (req: any, applicantId: string) => {
  const ep = epComments + "/" + applicantId;
  return new Promise<comment>((resolve, reject) => {
    api
      .put<CommentRes>(ep, req, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.comment);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const moveApplicant = (req: any) => {
  const ep = epApplicant + "/move/" + req.src_applicant.id;
  return new Promise((resolve, reject) => {
    api
      .put(ep, req, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.applicant);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const editLabel = (req: any) => {
  const ep = epLabels + "applicant/" + req.applicant_id;
  return new Promise<Label>((resolve, reject) => {
    api
      .put<ApplicantLabelRes>(ep, req, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.applicant_label);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const createApplicantMembership = (req: any) => {
  const ep = epMembers + "applicantMembership/" + req.id;
  return new Promise<Member>((resolve, reject) => {
    api
      .post<ApplicantMembershipRes>(ep, req, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.applicant_members);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const removeApplicantMembership = (req: any) => {
  const ep = epMembers + "applicantMembership/" + req.applicant_id;
  return new Promise<boolean>((resolve, reject) => {
    api
      .delete<ApplicantMembershipRes>(ep, {
        headers: authHeader(),
        data: req,
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(true);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const archieveUnArchiveApplicant = (req: any) => {
  const ep = epApplicant + `/archiveUnarchive/` + req.id;
  return new Promise<Applicant>((resolve, reject) => {
    api
      .put<ApplicantRes>(ep, req, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.applicant);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const getArchivedApplicants = (openingID: string) => {
  const ep = epApplicant + `/${openingID}/archived`;
  return new Promise<Applicant[]>((resolve, reject) => {
    api
      .get<getArchivedApplicantsRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.applicants);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const getArchivedLists = (openingID: string) => {
  const ep = epList + `archiveLists/${openingID}`;
  return new Promise<List[]>((resolve, reject) => {
    api
      .get<getArchivedListsRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.archived_list);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
//get attachment
export const getApplicantAttachments = (applicantID: string) => {
  const ep = epAttachment + `applicants/${applicantID}`;
  return new Promise<Attachment[]>((resolve, reject) => {
    api
      .get<getApplicantAttachmentsRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.attachments);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const moveList = (req: any) => {
  const ep = epList + "move/" + req.id;
  return new Promise((resolve, reject) => {
    api
      .put(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.move_list);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const moveListAplicants = (req: any) => {
  const ep = epList + "moveListApplicants/" + req.id;
  return new Promise((resolve, reject) => {
    api
      .put(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.move_list_applicants);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const dragApplicant = (dragedApplicant: any) => {
  const ep = epApplicant + "/move/" + dragedApplicant.src_applicant.id;
  return api.put(ep, dragedApplicant, { headers: authHeader() });
};

export const deleteLabel = (req: any) => {
  const ep = epLabels + "applicant/";
  return api.delete(ep, { headers: authHeader(), data: req });
};

export const archivedAll = (req: any) => {
  const ep = epList + "archiveAllApplicants/" + req.id;
  return new Promise((resolve, reject) => {
    api
      .put(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.list);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const copyApplicant = (req: any) => {
  const ep = epApplicant + "/copy/" + req.src_applicant.id;
  return new Promise((resolve, reject) => {
    api
      .post(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.copy_applicant);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//upload attachment
export const addAttachment = (
  formData: any,
  id: string,
  onUploadProgress?: any,
  onDownloadProgress?: any
) => {
  const ep = epAttachment + id;
  return new Promise<AddAttachment>((resolve, reject) => {
    api
      .post<AddAttachmentRes>(ep, formData, {
        headers: atsUploadHeader(),
        onUploadProgress,
        onDownloadProgress,
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.attachment);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const copyAttachments = (ats: { [key: string]: Attachment[] }) => {
  const ep = epAttachment + "copy";
  return new Promise<Attachment[]>((resolve, reject) => {
    api
      .post<copyAttachmentsRes>(ep, ats, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.attachment);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const deleteApplicantAttachment = (req: any) => {
  const ep = epAttachment;
  return new Promise((resolve, reject) => {
    api
      .delete(ep, { headers: authHeader(), data: req })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.deleted_attachment);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const updateApplicantAttachment = (attachment: any) => {
  const ep = epAttachment + attachment.id;
  return new Promise<Attachment>((resolve, reject) => {
    api
      .put<updateApplicantAttachmentRes>(ep, attachment, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.attachment);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const setTokenInLocalStorage = (
  tokenIdentifire: string,
  token: string
) => {
  return new Promise<boolean>((resolve, reject) => {
    try {
      localStorage.setItem(tokenIdentifire, token);
      resolve(true);     
    } catch {
      reject(false);
    }
  });
};

export const setTokenInSessionStorage = (token: string) => {
  return new Promise<boolean>((resolve, reject) => {
    try {
      sessionStorage.setItem("current_tab_application_token", token);
      resolve(true);
    } catch {
      reject(false);
    }
  });
};
export const setAnyTokenInSessionStorage = (key: string,value:string) => {
  return new Promise<boolean>((resolve, reject) => {
    try {
      sessionStorage.setItem(key, value);
      resolve(true);
    } catch {
      reject(false);
    }
  });
};


/********************************* fusion auth  ******************************/


// get user 
export const getUser = (user_id: string) => {
  const ep = epFusion + `retrive/${user_id}`;
  return new Promise<User>((resolve, reject) => {
    api
      .get<registrationRes>(ep, { headers: authHeader1() })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.user.user);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
//update invitation status
export const updateInvitationStatusApi = (req: any) => {
  const ep = epFusion + "invitation/status";
  return new Promise<OutgoingInvitations>((resolve, reject) => {
    api
      .put<inviteMemberRes>(ep, req, { headers: authHeader1() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.invitation);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};


//login
export const login = (loginObject: any) => {
  const ep = epFusion + "login";
  return new Promise<Register>((resolve, reject) => {
    api
      .post<registrationRes>(ep, loginObject)
      .then((res) => {
        if (res.status == 200 || res.status == 212) {
          resolve(res.data.user);
        }
      })
      .catch((reason: any) => {
        reject(reason);
      });
  });
};

//token exchange
export const JWTtokenExchange = (orgId: string, loginUserId: string) => {
  const ep = epFusion + `jwt/exchange/${orgId}/${loginUserId}`;
  return new Promise<string>((resolve, reject) => {
    api
      .get<JWTtokenExchangeRes>(ep, { headers: authHeader1() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.application_based_token.token);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//getOrg member
export const getOrgMember = (orgId: string) => {
  const ep = epFusion + `${orgId}`;
  return new Promise<Member[]>((resolve, reject) => {
    api
      .get<getOrgMemberRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.user);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};


/************************************* DB manager apis ****************************/




export const getOrgDetails = (orgId: any) => {
  const ep = epDbmanager + `orgs/${orgId}`;
  return new Promise<newOrganisation>((resolve, reject) => {
    api
      .get<createOrgRes>(ep, { headers: authHeader1() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.organisation);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};



/*********************************************** Acitity **********************************************************/
export const getActivityByPagination = (modelName: string, modelId: any, page?: string, per_page?: string) => {
  let ep: string;

    ep =
    epActivity + `${modelName}/${modelId}/?page=${page}&per_page=${per_page}`;
    return new Promise<PaginationActivity & paginationDetails>(
      (resolve, reject) => {
        api
          .get<ActivityPaginationRes>(ep, { headers: authHeader() })
          .then((res) => {
            if (res.status == 200) {
              resolve(res.data.activities);
            }
          })
          .catch((reason: any) => {
            throwError(reason);
            reject(reason);
          });
      }
    );
};
export const getActivity = (modelName: string, modelId: any) => {
  const ep = epActivity + `${modelName}/${modelId}`;
  return new Promise<activity[]>((resolve, reject) => {
    api
      .get<ActivityRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          res.data.activities = res.data.activities ? res.data.activities : [];
          resolve(res.data.activities);
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason);
      });
  });
};
/*************************************** notification **************************************************************/

// addWatcher
export const addWatcher = (Req: addWatcherReq) => {
  const ep = epNotification + `subscriptions`;
  return new Promise<addWatcherRes>((resolve, reject) => {
    api
      .post<addWatcherRes>(ep, Req, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

// addWatcher
export const removeWatcherOfEntity = (entity_id: string,entity_name:string,user_id:string) => {
  const ep = epNotification + `subscriptions/${entity_name}/${entity_id}/${user_id}`;
  return new Promise<addWatcherRes>((resolve, reject) => {
    api
      .delete(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

// getWatcher
export const getWatcherOfEntity = (entity_id: string) => {
  const ep = epNotification + `subscriptions/${entity_id}`;
  return new Promise<getWatcherRes>((resolve, reject) => {
    api
      .get<getWatcherRes>(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};



// ***************************************************** calender *************************************************************//
// incomplete
// getEvent
export const getEvent = (event_id: string) => {
  const ep = epBilling + `customers/${event_id}/free_tier_limit`;

  return new Promise<getFreeTierQuotaRes>((resolve, reject) => {
    api
      .get<getFreeTierQuotaRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        if (reason.response?.status == 404) {
          reject(reason);
        }
      });
  });
};

// createCardEvent
export const createCardEvent = (req: FormData | undefined) => {
  const ep = epCalender + `events`;

  return new Promise<CreateCardEventRes>((resolve, reject) => {
    api
      .post<CreateCardEventRes>(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data.event);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

// UserRequirementFeedbackFormReq



// createBoardCalender
export const createBoardCalender = (req: createBoardCalenderReq): Promise<createBoardCalRes> => {
  let startTime = performance.now() // Start timing
  return new Promise<createBoardCalRes>((resolve, reject) => {
    api
      .post<createBoardCalRes>(epCalender, req, { headers: authHeader() })
      .then((res) => {
        let endTime = performance.now() // End timing when response arrives
        let elapsedTime = endTime - startTime 
        if (elapsedTime < 1500) {
          // If response arrives within 300 milliseconds
          setTimeout(() => {
            resolve(res.data) // Resolve after 500 milliseconds
          }, 1500 - elapsedTime)
        } else {
          if (res.status == 200 || res.status == 201) {
            resolve(res.data)
          }
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};


// updateBoardCalender
export const updateBoardCalendar = (
  req: createBoardCalenderReq,
  cal_id: string
) => {
  const ep = epCalender + `${cal_id}`;

  return new Promise<createBoardCalRes>((resolve, reject) => {
    api
      .put<createBoardCalRes>(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        if (reason.response?.status == 404) {
          throwError(reason);
          reject(reason);
        }
      });
  });
};
// getBoardCalender
export const getBoardCalender = (cal_id: string) => {
  const ep = epCalender + `${cal_id}`;

  return new Promise<createBoardCalRes>((resolve, reject) => {
    api
      .get<createBoardCalRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        if (reason.response?.status == 404) {
          reject(reason);
        }
      });
  });
};

// getCalenderByBoardID
export const getCalenderByBoardID = (board_id: string) => {
  const ep = epCalender + `board/${board_id}`;

  return new Promise<getCalenderRes>((resolve, reject) => {
    api
      .get<getCalenderRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

// getEventByID
export const getEventByID = (event_id: string) => {
  const ep = epCalender + `events/${event_id}`;

  return new Promise<getEventByIDRes>((resolve, reject) => {
    api
      .get<getEventByIDRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

// getCardEvents
export const getCardEvents = (card_id: string) => {
  const ep = epCalender + `events/card/${card_id}`;

  return new Promise<getCardEventRes>((resolve, reject) => {
    api
      .get<getCardEventRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};



// deleteCalEvent
export const deleteCalEvent = (event_id: string, socket_client_id: string) => {
  const ep = epCalender + `events/${event_id}/${socket_client_id}`;

  return new Promise<deleteCalEventRes>((resolve, reject) => {
    api
      .delete<deleteCalEventRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
// updateCalEvent
export const updateCalEvent = (event_id: string, req: createCardEventReq) => {
  const ep = epCalender + `events/${event_id}`;

  return new Promise<CreateCardEventRes>((resolve, reject) => {
    api
      .put<CreateCardEventRes>(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        if (reason.response?.status == 404) {
          reject(reason);
        }
      });
  });
};

// editCalEvent
export const editCalEvent = (event_id: string, req: FormData | undefined) => {
  const ep = epCalender + `events/${event_id}`;

  return new Promise<getEventByIDRes>((resolve, reject) => {
    api
      .put<getEventByIDRes>(ep, req, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};





//addAttachmentInCalEvent
export const getAttachmentByEventID = (event_id: string) => {
  const ep = epCalender + `event/attachments/events/${event_id}`;

  return new Promise<getEventAttachmentRes>((resolve, reject) => {
    api
      .get<getEventAttachmentRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        if (reason.response?.status == 404) {
          reject(reason);
        }
      });
  });
};

// getBoardCalenderEvents
export const getBoardCalenderEvents = (cal_id: string) => {
  const ep = epCalender + `events/board/${cal_id}`;

  return new Promise<getBoardCalendarEventRes>((resolve, reject) => {
    api
      .get<getBoardCalendarEventRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};


// deleteAttachmentByAttachmentID
export const deleteCalAttachment = (attachment_id: string) => {
  const ep = epCalender + `event/attachments/${attachment_id}`;

  return new Promise<deleteCalAttachmentRes>((resolve, reject) => {
    api
      .delete<deleteCalAttachmentRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        if (reason.response?.status == 404) {
          reject(reason);
        }
      });
  });
};

// deleteAttachmentByEventID will call if event deletion performs
export const deleteCalEventAttachments = (event_id: string) => {
  const ep = epCalender + `event/attachments/event/${event_id}`;

  return new Promise<deleteCalAttachmentRes>((resolve, reject) => {
    api
      .delete<deleteCalAttachmentRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

// removeZoomFromBoardUsingCalID
export const removeZoomFromBoardUsingCalID = (cal_id: string) => {
  const ep = epCalender + `zoom/settings/${cal_id}`;

  return new Promise<removeZoomFromBoardUsingCalIDRes>((resolve, reject) => {
    api
      .delete<removeZoomFromBoardUsingCalIDRes>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};



// getBoardCalenderSettingsOfCTools
export const getBoardCalenderSettingsOfCTools = (cal_id: string) => {
  const ep = epCalender + `conference/calendar/settings/${cal_id}`;

  return new Promise<any>((resolve, reject) => {
    api
      .get<any>(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          alert("invalid credentials");
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

/*************************************** OPA  ************************************************************ */
export const editRoleOfBoardMember = (req: any) => {
  const ep = epOpa + "membership/access";
  return new Promise<Member>((resolve, reject) => {
    api
      .patch(ep, req, {
        headers: authHeader(),
      })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.member);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

/*************************** candidate DB  *********************************/
export const getCandidate = (cid:string) => {
  const ep = epCDB + `candidates/id?id=${cid}`;
  return new Promise<Candidate>((resolve, reject) => {
    api
      .get<getCandidateRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.candidates);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};





export const getCandidates = (currentPage: number, pageSize: number,job_id?:string) => {
  let ep = epCDB + `candidates?page=${currentPage}&per_page=${pageSize}`;
  if (job_id) {
    ep += `&job_id=${job_id}`;
  }  return new Promise<PaginationCandidates & paginationDetails>(
    (resolve, reject) => {
      api
        .get<getCandidatesRes>(ep, {
          headers: authHeader(),
        })
        .then((res) => {
          if (res.status == 200) resolve(res.data.candidates);
        })
        .catch((reason: any) => {
          throwError(reason);
          reject(reason);
        });
    }
  );
};

export const getLabels = (entity: string) => {
  const ep = epCDB + `labels?entity=${entity}`;
  return new Promise<Label[]>((resolve, reject) => {
    api
      .get<getBoardLabelRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.labels);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const getCandidateLabel = (candidateID: string) => {
  const ep = epCDB + `labels/candidate?id=${candidateID}`;
  return new Promise<Label[]>((resolve, reject) => {
    api
      .get<getBoardLabelRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.labels);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//single label on candidate
export const attachLabelToCandidate = (req: attachLabelToCandidateReq) => {
  const ep = epCDB + `labels/attach/tocandidate`;
  return new Promise<candidateLabel>((resolve, reject) => {
    api
      .post<attachLabelToCandidateRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.candidate_labels);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
//bulk label on candidate
export const attachBulkLabelsToCandidates = (
  req: deleteLabelFromCandidateReq
) => {
  const ep = epCDB + `labels/bulk/tocandidate`;
  return new Promise<reviewsLabel>((resolve, reject) => {
    api
      .post<attachBulkLabelsToCandidatesRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.candidate_labels);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const editCandidate = (candidateReq: any) => {
  const ep = epCDB + `candidates`;

  return new Promise<Candidate>((resolve, reject) => {
    api
      .patch<getCandidateRes>(ep, candidateReq, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.candidates);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const getAttachments = (model: string, recordId: string) => {
  const ep = epCDB + `attachments?model_name=${model}&record_id=${recordId}`;
  return new Promise<Attachment[]>((resolve, reject) => {
    api
      .get<getApplicantAttachmentsRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.attachments);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const deleteAttachmentOfCandidate = (recordId: string) => {
  const ep = epCDB + `attachments?id=${recordId}`;
  return new Promise<Attachment[]>((resolve, reject) => {
    api
      .delete<getApplicantAttachmentsRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.attachments);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//get candidate boards
export const getCandidateApplication = (candidateId: string) => {
  const ep = epCDB + `candidates/cards?id=${candidateId}`;
  return new Promise<Applicant[]>((resolve, reject) => {
    api
      .get<getCandidateApplicationRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.candidate_applicants);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const getReviewComments = (id: string) => {
  const ep = epCDB + `comments?id=${id}`;
  return new Promise<ReviewComment[]>((resolve, reject) => {
    api
      .get<getReviewCommentsRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.comments);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const createReviewComment = (req: AddCommentOnReviewReq) => {
  const ep = epCDB + `comments`;
  return new Promise<ReviewComment>((resolve, reject) => {
    api
      .post<createReviewCommentRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          resolve(res.data.comments);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//assign memner
export const assignMemberToReview = (req: AssignMemberToReviewReq) => {
  const ep = epCDB + `members/attach/toreview`;
  return new Promise<AssignMemberToReview>((resolve, reject) => {
    api
      .post<assignMemberToReviewRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          resolve(res.data.review_members);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const uploadAttachmentOfCandidate = (
  formData: any,
  modelName: string,
  recordId: string,
  org_id:string,
  user_id:string,
) => {
  const ep =
    epCDB + `attachments/pub?model_name=${modelName}&record_id=${recordId}&org_id=${org_id}&user_id=${user_id}&type=form`;
  return new Promise<Attachment[]>((resolve, reject) => {
    api
      .post<uploadAttachmentOfCandidateRes>(ep, formData, {
        headers: atsUploadHeader(),
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.attachments);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const attachLabelToReview = (req: any) => {
  const ep = epCDB + `labels/attach/toreview`;
  return new Promise<candidateLabel>((resolve, reject) => {
    api
      .post<attachLabelToReviewRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.review_labels);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const updateCandidateAttachment = (attachment: any) => {
  const ep = epCDB + "attachments";
  return new Promise<Attachment>((resolve, reject) => {
    api
      .patch<updateCandidateAttachmentRes>(ep, attachment, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.attachments);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
// check otp
export const checkPhoneOtp = (req: checkOtpToUserPhoneReq) => {
  const ep = epFusion + "mobile/otp/check";
  return new Promise<sentOtpToUserPhoneRes>((resolve, reject) => {
    api
      .post<sentOtpToUserPhoneRes>(ep, req, { headers: authHeader1() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data);
        }
      })
      .catch((reason: any) => {
        reject(reason);
      });
  });
};

export const getCandidateReviews = (cId: string) => {
  const ep = epCDB + `reviews/candidate?id=${cId}`;
  return new Promise<CandidateShortReview[]>((resolve, reject) => {
    api
      .get<getReviewsOfSelectedCandidate>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.reviews);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const removeMemberFromCurrentReview = (req: any) => {
  const ep = epCDB + "members/attach/toreview";
  return new Promise<AssignMemberToReview>((resolve, reject) => {
    api
      .delete<assignMemberToReviewRes>(ep, {
        headers: authHeader(),
        data: req,
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.review_members);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const CreateCandidateCard = (req: any) => {
  const ep = epCDB + `candidates/card`;
  return new Promise<candidateLabel>((resolve, reject) => {
    api
      .post<any>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const CloseReview = (ids: {
  reviews: string[] | React.Key[]
}) => {
  const ep = epCDB + `reviews/close`;
  return new Promise<CandidateShortReview[]>((resolve, reject) => {
    api
      .post<any>(ep, ids, {
          headers: authHeader(),
        }
      )
      .then((res) => {
        if (res.status == 200)
          resolve(res.data.reviews);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const editCDBRole = (req: any) => {
  const ep = epCDB + "members/edit/role";
  return new Promise<Member>((resolve, reject) => {
    api
      .put(ep, req, {
        headers: authHeader(),
      })
      .then((res: any) => {
        if (res.status == 200) {
          resolve(res.data.members);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const removeCandidateMember = (req: any) => {
  const ep = epCDB + "members";
  return api.delete(ep, { headers: authHeader(), data: req });
};

export const editCommentOfReview = (req: EditCommentOfReviewReq) => {
  const ep = epCDB + "comments";
  return new Promise((resolve, reject) => {
    api
      .patch<editCommentOfReviewRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.comments);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const addLabelToBulkReview = (req: addLabelsToBulkReviewReq) => {
  const ep = epCDB + `labels/bulk/toreview`;
  return new Promise<bulkLabel[]>((resolve, reject) => {
    api
      .post<addLabelToBulkReviewRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.reviews_labels);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

export const addMemberToBulkReview = (req: addMembersToBulkReviewReq) => {
  const ep = epCDB + `members/bulk/toreview`;
  return new Promise<bulkMember[]>((resolve, reject) => {
    api
      .post<addMembersToBulkReviewRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.review_members);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

/******************************************Tacitmail  *******************************/

//create domain
export const addCustomDomain = (req: addCustomDomainReq) => {
  const ep = epMail + `domain/switch`;
  return new Promise<Domain>((resolve, reject) => {
    api
      .post<addCustomDomainRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.domain);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//verify domain

export const verfityDomain = (domaninId: string) => {
  const ep = epMail + `domain/verify?id=${domaninId}`;
  return new Promise<Domain>((resolve, reject) => {
    api
      .get<verifyDomainRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.verified_domain);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//get domain
export const getDomain = () => {
  const ep = epMail + `domain`;
  return new Promise<Domain>((resolve, reject) => {
    api
      .get<addCustomDomainRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.domain);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
//create ses identity

export const CreateSESIdebtity = (domaninId: string) => {
  const ep = epMail + `domain/verify?id=${domaninId}`;
  return new Promise<bulkMember[]>((resolve, reject) => {
    api
      .post<addMembersToBulkReviewRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.review_members);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//send message

export const sendMail = (req: sendMailReq) => {
  const ep = epMail + `imbox/compose`;
  return new Promise<SendMail>((resolve, reject) => {
    api
      .post<sendMailres>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.message);
      })
      .catch((reason: any) => {
        // throwError(reason)
        reject(reason);
      });
  });
};

//get user imbox
export const getUserInbox = (tab: string, currentPage: number,
  pageSize: number) => {
  const ep = epMail + `imbox?page=${currentPage}&per_page=${pageSize}&filter=${tab}`;
  return new Promise<paginationDetails & paginationMail>((resolve, reject) => {
    api
      .get<getUserInboxRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.imboxs);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//get message thread
export const getThreadOfMessage = (id: string, key: string) => {
  const ep = epMail + `imbox/threads?record_id=${id}&initial_key=${key}`;
  return new Promise<RecordThreads>((resolve, reject) => {
    api
      .get<getThreadOfMessageRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.record_threads);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//get message thread
export const getUserThreadOfMessage = (id: string) => {
  const ep = epMail + `imbox/user/threads?message_id=${id}`;
  return new Promise<RecordThreads>((resolve, reject) => {
    api
      .get<getThreadOfMessageRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.record_threads);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//mark mail as read
export const markMailAsRead = (id: string) => {
  const ep = epMail + `imbox/read?id=${id}`;
  return new Promise<Mail>((resolve, reject) => {
    api
      .put<markMailAsReadRes>(ep, id, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.message);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//mark message as important
export const markMailAsImportant = (id: string) => {
  const ep = epMail + `imbox/read?id=${id}&important=true`;
  return new Promise<Mail>((resolve, reject) => {
    api
      .post<markMailAsReadRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.message);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

//add attachment to mail
export const addAttachmentToMail = (formData: any, onUploadProgress: any) => {
  const ep = epMail + `imbox/attachments`;
  return new Promise<Attachment[]>((resolve, reject) => {
    api
      .post<getApplicantAttachmentsRes>(ep, formData, {
        headers: authHeader(),
        onUploadProgress,
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.attachments);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};
export const downloadAttachmentOfMail = (objectKey: string) => {
  const ep = epMail + `imbox/attachments?key=${objectKey}`
  return new Promise((resolve, reject) => {
    api
      .get(ep, {
        headers: authHeader(),
      })
      .then((res: any) => {
        if (res.status == 200) resolve(res.data.presign)
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
};

//get record mail preview
export const getRecordMailPreview = (id: string) => {
  const ep = epMail + `imbox/record?record_id=${id}`;
  return new Promise<paginationDetails & paginationMail>((resolve, reject) => {
    api
      .get<getUserInboxRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.imboxs);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

// ********* Plugin ***********

// getAllMappings
export const getAllMappings = () => {
  const ep = epCDB + `plugin/mappings`;
  return new Promise<getAllMappingsRes>((resolve, reject) => {
    api
      .get<getAllMappingsRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

// getMapping

export const getMapping = () => {
  const ep = epCDB + `plugin/mapping?app_name=Linkedin`;
  return new Promise<getMappingRes>((resolve, reject) => {
    api
      .get<getMappingRes>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};

// updateMapping

export const updateMapping = (m_id: string, req: any) => {
  const ep = epCDB + `plugin/mapping?mapping_id=${m_id}`;
  return new Promise<updateMappingRes>((resolve, reject) => {
    api
      .put<updateMappingRes>(ep, req, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};


/********************************************** form builder **********************************************************/

//create form 
export const createForm = (formData?: FormData) => {
  const ep = epJD + `form`
  return new Promise<FormBuilder>((resolve, reject) => {
    api
      .post(ep, formData, { headers: authHeader() })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.form)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}

// get form
export const getAllBuildForm = () => {
  const ep = epJD + `form_builder`
  return new Promise<FormBuilder[]>((resolve, reject) => {
    api
      .get(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.forms)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}

//get form by id
export const getFormById = (formId: string) => {
  const ep = epJD + `form_builder` + `/${formId}`
  return new Promise<FormBuilder>((resolve, reject) => {
    api
      .get(ep, { headers: authHeader() })
      .then((res: any) => {
        if (res.status === 200) {
          resolve(res.data.form)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}

//create jd
export const createCandidateFromLink = (formData?: FormData) => {
  const ep = epCDB + `candidates/from/JD`
  return new Promise<FormBuilder>((resolve, reject) => {
    api
      .post(ep, formData)
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}

//update form
export const updateFormById = (formId: string, formData: any) => {
  const ep = epJD + `form_builder` + `/${formId}`
  return new Promise((resolve, reject) => {
    api
      .patch(ep, formData, { headers: authHeader() })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.form)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}


/************************************************ JD  *****************************/

//create jd
export const createJd = (jdData?: FormData) => {
  const ep = epJD
  return new Promise<Jd>((resolve, reject) => {
    api
      .post(ep, jdData, { headers: authHeader() })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.jd)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}
export const getAllJobDescription = () => {
  const ep = epJD
  return new Promise<Jd[]>((resolve, reject) => {
    api
      .get(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.jds)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}
export const getAllJobOfOrg = async (orgId: string, page: number, perPage: number) => {
  const ep = `v1/public/public-service/all/orgjd?org_id=${orgId}&page=${page}&per_page=${perPage}`;
  try {
    const res = await api.get(ep);
    if (res.status === 200) {
      return res.data.jds;
    }
  } catch (error) {
    console.error("Failed to fetch jobs:", error);
    throw error; 
  }
};


// getting available integrations
export const getAvailableIntegrations = async ()=>{
  const ep = epJD + "integrations/"
  return new Promise<any>((resolve, reject) => {
    api
      .get(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.integrations)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}
//get integration of jd
export const getIntegrationsOfJD = (jd_id: string) => {
  const ep = epJD + "integrations/" + jd_id
  return new Promise<any>((resolve, reject) => {
    api
      .get(ep, { headers: authHeader() })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.jd_integrations)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}
//update integration of jd
// export const updateIntegrationStatus = (jd_id: string, req: any) => {
//   const ep = epJD + "integrations/" + jd_id
//   return new Promise<{ jd_id: string, integrations: Integrations[] }>((resolve, reject) => {
//     api
//       .patch(ep, req, { headers: authHeader() })
//       .then((res) => {
//         if (res.status === 200) {
//           resolve(res.data.jd_integrations)
//         }
//       })
//       .catch((reason: any) => {
//         throwError(reason)
//         reject(reason)
//       })
//   })
// }

//attached form
export const attachedFormToJD = (req: any) => {
  const ep = epJD + "attached_form_to_jd"
  return new Promise<{ id: "", title: "" }>((resolve, reject) => {
    api
      .put(ep, req, { headers: authHeader() })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.jd_form)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}





export const getJDbyBoardId = (boardId: string) => {
  const ep = epJD + `board/${boardId}`; 

  return new Promise<Jd>((resolve, reject) => {
    api.get(ep,{ headers: authHeader() }).then((res) => {
      if (res.status === 200) {
        resolve(res.data.jd);
      } else {
        reject(new Error('Failed to fetch job description'));
      }
    }).catch((reason: any) => {
      reject(reason);
    });
  });
};



// ******************* Import ********************** //



// get Import reports
export const getImportReports = () => {
  const ep = epCDB + `candidates/import`;
  return new Promise<ImportReport[]>((resolve, reject) => {
    api
      .get(ep,  {
        headers: authHeader(),       


      })
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          resolve(res.data.reports);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};




/*********************************************** Campany creation  *********************************************/

export const readNotification = (model_id:string|null,model_name:string|null) => {
  let ep = `${epRTU}/pvt/workers/readall?model_id=${model_id}&model_name=${model_name}&socket_client_id=${sessionStorage.getItem(SOCKET_CLIENT_ID)}`;  
   return new Promise((resolve, reject) => {
    api
      .put(ep,null, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.time)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}

// set watcher
export const setUserWatcherOfModel = (model_id:string|null,model_name:string|null,watch:boolean) => {
  let ep = `${epRTU}/pvt/workers/watch`;
   return new Promise((resolve, reject) => {
    api
      .put<getWatcherOfModelRes>(ep,{watch:watch,model_type:model_name,model_id:model_id}, { headers: authHeader() })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.watcher)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}







/********************************************* GPT  ****************************************************/



export const ResumeParserAttachment = (formData: any) => {
  const ep = epCDB + `candidates/resumes`;
  return new Promise<any>((resolve, reject) => {
    api
      .post<any>(ep, formData, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) resolve(res.data.candidates);
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
};



// redirect link api
export const redirectToNewJD = (jobId: string) => {
  const ep = epPublicService + `links/careerpage/job?job_id=${jobId}`
  return api.get(ep)
    .then((res) => {
      if (res.status === 200) {
        return res.data.links
      }
    })
    .catch((error: any) => {
      throwError(error)
      throw error // Re-throw the error to propagate it further
    })
}




//Function for fetching the all sources 
export const getAllSources = () => {
  const ep = epJD + "source";
  return new Promise<Source[]>((resolve, reject) => {
    api
      .get<SourcesResponse>(ep, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.source_tracking);
        }
      })
      .catch((reason: any) => {
        throwError(reason);
        reject(reason);
      });
  });
}


//getApplicantStatus
export const getApplicantStatus = (ids: { ids: string[] }) => {
  const ep = epCDB + "candidates/bulk/activity"
  return new Promise((resolve, reject) => {
    api
      .post(ep, ids, {
        headers: authHeader(),
      },)
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data.activities)
        }
      })
      .catch((reason: any) => {
        throwError(reason)
        reject(reason)
      })
  })
}









//  api's
// Login 


export const guestLogin = (base64:string) => {
  const ep = epFusion + `login/${base64}`;

  return new Promise<Login>((resolve, reject) => {
    api
      .post<guestLoginRes>(ep, null)
      .then((res) => {
        if (res.status == 200 || res.status == 212) {
          resolve(res.data.login);
        }
      })
      .catch((reason: any) => {
        reject(reason);
      });
  });
};

export const generateSecureLink = (base64:string) => {
  const ep = epFusion + `login/secret/regenerate?secret=${base64}`;

  return new Promise<Secret>((resolve, reject) => {
    api
      .post<generateSecureLinkRes>(ep, null)
      .then((res) => {
        if (res.status == 200 || res.status == 212) {
          resolve(res.data.secret);
        }
      })
      .catch((reason: any) => {
        reject(reason);
      });
  });
};


